import React from 'react';
import ContentLoader from 'react-content-loader';

const BuyTicketsCardSkeleton = () => {
  return (
    <ContentLoader
      backgroundColor="var(--neutral-200)"
      foregroundColor="var(--neutral-400)"
      className="w-[320px] h-[158px] rounded-lg hidden md:block"
    >
      <rect x="0" y="0" height="100%" width="100%" />
    </ContentLoader>
  );
};

export default BuyTicketsCardSkeleton;
